module.exports = __webpack_public_path__ + "static/img/button2.eb82a09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/button2.png
// module id = QSNc
// module chunks = 1